import { css } from 'styled-components';
import { getIcon } from './icons';
import { typography, getTypography } from './typography';
import { elevation } from './elevation';
import { rating } from './rating';
import { richtext } from './richtext';
import { textField } from './textField';
import { textarea } from './textarea';
import { button, buttonContained } from './button';
import { iconButton } from './iconButton';

const palette = {
  primary: {
    main: '#50bea4',
    dark: '#50bea4',
    light: '#50bea4',
    contrastText: '#fff',
  },
  secondary: {
    main: '#50bea4',
    dark: '#50bea4',
    light: '#50bea4',
    contrastText: '#fff',
  },
  default: {
    main: '#e0e0e0',
    light: '#eee',
    dark: '#bdbdbd',
    contrastText: '#212121'
  },
};

const spacing = { xxs: '2px', xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px', xxl: '40px' };

const ticks = css`
	ul {
		padding: 0;
		margin: 0 -24px;

		li {
			list-style: none;
			padding: 16px 16px 16px 56px;
			border-bottom: 1px solid #ddd;
			background: transparent url("${({ theme }) => theme.helpers.getIcon('check', theme.palette.primary.main)}") no-repeat left 16px center;

			&:last-child {
				border: none;
			}
		}
	}
`;

export const theme = {
  palette,
  spacing,
  elevation,
  typography,
  ticks,
  getTypography,
  button,
  buttonContained,
  iconButton,
  rating,
  textField,
  textarea,
  richtext,
  border: {
    radius: '4px',
    color: '#ddd'
  },
  icon: {
    color: '#666'
  },
  link: css`
		color: inherit;
		text-decoration: none;

		&:hover {
			color: ${({ theme }) => theme.palette.primary.main};
			text-decoration: underline;
		}
	`,
  label: {
    severity: {
      error: '#ef5350',
      warning: '#ff9800',
      info: '#03a9f4',
      success: '#4caf50'
    }
  },
  alert: {
    severity: {
      error: { background: '#fdeded', text: '#5f2120' },
      warning: { background: '#fff4e5', text: '#663c00' },
      info: { background: '#edf7ed', text: '#014361' },
      success: { background: '#e5f6fd', text: '#1e4620' }
    }
  },
  helpers: {
    getIcon,
    hideText: css`
      text-indent: -9999px;
      white-space: nowrap;
      overflow: hidden;
    `,
  },
};
